import { useEffect } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContentText,
	DialogActions,
	DialogContent,
} from "@mui/material";

import { PrimaryBorderButton } from "../Buttons.js";

const AreYouSurePopup = ({
	open,
	title,
	content,
	onDecline,
	onAccept,
}) => {
	useEffect(() => {
		// console.log("Component mounted!");
	}, []);

	return (
		<Dialog
			open={open}
			onClose={() => onDecline()}
		>
			<DialogTitle>
				{title}
			</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{content}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<PrimaryBorderButton title="Cancel" onClick={() => onDecline()} />
				<PrimaryBorderButton title="Do it!" onClick={() => onAccept()} />
			</DialogActions>
		</Dialog>
	);
};

export default AreYouSurePopup;
